<template>
	<div class="p2p_detail">
		<div class="d_flex align_items_center mb_16" @click="$emit('showList')">
			<span class="LEFTARROW mr_8"></span>
			<h3 class="title_s">{{ $t('rtr_activity-c2c.title4') }}</h3>
		</div>
		<div class="item_box type1 mb_40">
			<div class="asset_box icon_box mb_16">
				<span :class="[applicationInfo.source_asset_code, 'medium']"></span>
				<div>
					<p class="code mb_4">{{ applicationInfo.source_asset_code }}</p>
					<p class="name">{{ applicationInfo.source_asset_title }}</p>
				</div>
			</div>
			<div class="detail_box">
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
					<div class="asset_box">
						<span :class="[applicationInfo.target_asset_code, 'small']"></span>
						<p class="code mr_4">{{ applicationInfo.target_asset_code }}</p>
						<p class="name">{{ applicationInfo.target_asset_title }}</p>
					</div>
				</div>
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.account_number') }}</p>
					<p>{{ applicationInfo.deal_account_number }}</p>
				</div>
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.sold_quantity') }}</p>
					<p>
						{{ applicationInfo.source_amount }}
						<span>{{ applicationInfo.source_asset_code }}</span>
					</p>
				</div>
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.sold_price') }}</p>
					<p>
						{{ applicationInfo.price }}
						<span>{{ applicationInfo.target_asset_code }}</span>
					</p>
				</div>
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.total_fee') }}</p>
					<p>{{ applicationInfo.fee_amount }}</p>
				</div>
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.status') }}</p>
					<p>{{ $t('c2c.' + applicationInfo.status) }}</p>
				</div>
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.registration_date') }}</p>
					<p>
						{{ $dayjs(applicationInfo.regdate).format('YYYY.MM.DD HH:mm:ss') }}
					</p>
				</div>
				<template v-if="escrowType === 'DEALER' || escrowType === 'DISABLE'">
					<div
						v-if="
							applicationInfo.status === 'PENDING' ||
							applicationInfo.status === 'PAYED'
						"
						class="item"
					>
						<p>{{ $t('rtr_activity-c2c.amount_paid') }}</p>
						<p>
							{{
								parseFloat(applicationInfo.source_amount) *
								parseFloat(applicationInfo.price)
							}}
						</p>
					</div>
				</template>
			</div>
		</div>
		<Extform
			class="border_t_black mt_20 pt_20"
			v-for="extform in extforms"
			:key="extform.seq"
			v-bind="extform"
			v-model="extform.field_values"
			:readonly="true"
		/>
		<div class="button_area">
			<template v-if="escrowType === 'DEALER' || escrowType === 'DISABLE'">
				<button
					class="btn_ty_2 blue2 mb_8"
					v-if="
						applicationInfo.status === 'PENDING' ||
						applicationInfo.status === 'PAYED'
					"
					@click="privateApplicationHandler('SET_CONFIRMED')"
				>
					{{ $t('button.decide') }}
				</button>
				<button
					class="btn_ty_2"
					v-if="applicationInfo.status === 'PENDING'"
					@click="privateApplicationHandler('SET_REJECTED')"
				>
					{{ $t('button.reject') }}
				</button>
			</template>
			<template v-if="escrowType === 'APPLICANT'">
				<button
					class="btn_ty_2 button_bg_red mb_8"
					v-if="applicationInfo.status === 'PENDING'"
					@click="privateApplicationHandler('SET_PAYED')"
				>
					{{ $t('button.payment') }}
				</button>
				<button
					class="btn_ty_2"
					v-if="
						applicationInfo.status === 'PENDING' ||
						applicationInfo.status === 'PAYED'
					"
					@click="privateApplicationHandler('SET_REJECTED')"
				>
					{{ $t('button.reject') }}
				</button>
			</template>
		</div>
	</div>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'">
			<button class="button_bg_red button_m" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'">
			<button class="button_bg_red button_m" @click="confirmHandler">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import {
	confirmPrivateApplication,
	fetchPrivateApplication,
	payPrivateApplication,
	rejectPrivateApplication,
} from '@/api/application';
import { commonError } from '@/common/dialog';
import Extform from '@/components/Extform/Extform';

export default {
	name: 'SaleDetail',
	emits: ['showList'],
	props: {
		initInfo: Object,
	},
	components: { ModalMessageM, Extform },
	data() {
		return {
			applicationInfo: this.initInfo,
			escrowType: this.initInfo.escrow_type,
			patchType: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			extforms: [],
		};
	},
	created() {
		this.loadApplicationInfo().catch(commonError);
	},
	methods: {
		async loadApplicationInfo() {
			const { application_info, field_values, forms } =
				await fetchPrivateApplication(this.applicationInfo.seq).catch(
					commonError,
				);
			const extforms = forms.map(form => ({
				...form,
				fields: [],
				field_values: [],
			}));
			field_values.forEach(item => {
				const form = extforms.find(form => form.seq === item.form_seq);
				form.fields.push(item);
				form.field_values.push(item);
			});
			this.applicationInfo = application_info;
			this.extforms = extforms;
		},
		privateApplicationHandler(type) {
			this.patchType = type;
			let message = '';
			switch (type) {
				case 'SET_REJECTED':
					message = this.$t('button.reject');
					break;
				case 'SET_PAYED':
					message = this.$t('button.payment');
					break;
				case 'SET_CONFIRMED':
					message = this.$t('button.decide');
					break;
			}
			this.modalIcon = 'information';
			this.modalStatusMessage = message + this.$t('rtr_pay-exchange.text9');
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		confirmHandler() {
			this.messageModal = false;
			switch (this.patchType) {
				case 'SET_REJECTED':
					this.rejectPrivateApplication();
					break;
				case 'SET_PAYED':
					this.payPrivateApplication();
					break;
				case 'SET_CONFIRMED':
					this.confirmPrivateApplication();
					break;
			}
		},
		async confirmPrivateApplication() {
			await confirmPrivateApplication(this.applicationInfo.seq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_confirm');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadApplicationInfo();
				})
				.catch(commonError);
		},
		async payPrivateApplication() {
			await payPrivateApplication(this.applicationInfo.seq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_payment');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadApplicationInfo();
				})
				.catch(commonError);
		},
		async rejectPrivateApplication() {
			await rejectPrivateApplication(this.applicationInfo.seq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_reject');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadApplicationInfo();
				})
				.catch(commonError);
		},
	},
};
</script>
<style scoped></style>
